import { axiosHelper } from 'Services/AxiosHelper';
import { getApiGWTokenCookie } from 'Utils';
import { OnGetAccountWithCardsBodyData } from 'Config/ServiceConfig';

const command = 'RI.OnGetAccountWithCards';

const onGetAccountWithCards = async (params: OnGetAccountWithCardsBodyData): Promise<OnGetAccountWithCardsBodyData> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onGetAccountWithCards;
